export const columnDefs = [
  {
    field: 'hiringRequestId',
    headerName: 'Position ID',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'jobTitle',
    headerName: 'Job Title',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'numberOfPositions',
    headerName: 'Positions',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'lobName',
    headerName: 'LoB',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'projectName',
    headerName: 'Project Name',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'skillName',
    headerName: 'Primary Skills',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'desiredStartDate',
    headerName: 'Desired Start  Date',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'vendorName',
    headerName: 'Shared with Vendor',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'comments',
    headerName: 'Comments',
    filterParams: { hideMenu: true },
    sortParams: { enabled: false },
  },
  {
    field: 'priority',
    headerName: 'Priority',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'noOfCandidates',
    headerName: 'Candidates Received',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'status',
    headerName: 'Request Status',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'actions',
    headerName: 'Actions',
    filterParams: { hideMenu: true },
  },
];
